import { render } from "./ReturnPortalReturnEntireOrderSummary.vue?vue&type=template&id=0aa0477b"
import script from "./ReturnPortalReturnEntireOrderSummary.vue?vue&type=script&lang=js"
export * from "./ReturnPortalReturnEntireOrderSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__